/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_passkey_cancelled = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey authentication was cancelled`)
};

const zh_hans1_login_passkey_cancelled = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通行密钥认证已取消`)
};

const zh_hant1_login_passkey_cancelled = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已取消通行金鑰登入`)
};

const fr_login_passkey_cancelled = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La connexion par passkey a été annulée`)
};

const de_login_passkey_cancelled = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey-Authentifizierung wurde abgebrochen`)
};

const ja_login_passkey_cancelled = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキー認証がキャンセルされました`)
};

const ko_login_passkey_cancelled = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`패스키 로그인이 취소되었습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_passkey_cancelled = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_passkey_cancelled(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_passkey_cancelled", locale)
	if (locale === "en") return en_login_passkey_cancelled(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_passkey_cancelled(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_passkey_cancelled(inputs)
	if (locale === "fr") return fr_login_passkey_cancelled(inputs)
	if (locale === "de") return de_login_passkey_cancelled(inputs)
	if (locale === "ja") return ja_login_passkey_cancelled(inputs)
	return ko_login_passkey_cancelled(inputs)
};